module.exports = __webpack_public_path__ + "img/night sparrows unagi stand.bd92a32f.png";